<template>
  <div class="custom-fields">
    <slot :fields="fields" />
  </div>
</template>


<script setup lang="ts">
import DateField from '@/components/fields/Date.vue'
import { augmenters } from '@/composables/useFieldAugmenters'

import { CustomFieldDataType } from '~/_api/models/customField'

interface Props {
  data: any[]
}

const props = defineProps<Props>()

function resolve(dataType: string | CustomFieldDataType) {
  switch (dataType) {
    case CustomFieldDataType.date:
      return DateField
    case CustomFieldDataType.bool:
      return resolveComponent('USwitch')
    case CustomFieldDataType.number:
      return resolveComponent('UInputNumber')
    case CustomFieldDataType.longtext:
      return resolveComponent('UTextarea')
    case CustomFieldDataType.multiple:
      return resolveComponent('USelect')
    default:
      return resolveComponent('UInput')
  }
}

function getValue(field: any) {
  if (
    (field.value === undefined || field.value === null || field.value === '')
    && field.defaultValue !== undefined
    && field.defaultValue !== null
  ) {
    field.value = field.defaultValue
  }

  if (field.dataType === CustomFieldDataType.bool) {
    return Boolean(field.value)
  }

  return field.value
}

function getItems(field: any) {
  if (field.dataType === CustomFieldDataType.multiple) {
    return field.multipleValues.map((value: string) => { return { value, label: value } })
  }

  return undefined
}

const fields = computed(() => {
  return props.data.map((field) => {
    const isDate = field.dataType === CustomFieldDataType.date
    const isSelect = field.dataType === CustomFieldDataType.multiple

    return {
      component: resolve(field.dataType),
      label: field.name,
      props: {
        id: String(field.idCustomField),
        modelValue: getValue(field),
        ...(isSelect ? { items: getItems(field) } : {}),
        ...(isDate ? { augmenter: augmenters.timestamp } : {}),
      },
      events: {
        'update:modelValue': (value: any) => {
          field.value = value
        },
      },
    }
  })
})
</script>
